import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _15mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"15mp"} ref={ref}/>
});

_15mpIcon.displayName = "_15mpIcon";
